require('./views/resource-type');
